import { Box } from '@mui/material';
import { Button } from '@sweep-io/sweep-design';
import type { ComponentType } from 'react';
import type { DedupMatchingType } from '../../types/enums/DedupMatchingType';
import { usePermissions } from '../../permissions/usePermissions';
import RestrictedTooltip from '../common/permissions/RestrictedTooltip';
import { useCallback, useState } from 'react';
import { PageTemplateCanvasDialog } from '../pages/pages-templates/PageTemplateCanvasDialog';
import { DedupTemplateContent } from '../pages/dedup-and-matching/DedupTemplateContent';
import { useAutomationsContext } from './AutomationsContext';
import { useDefaultEnvId } from '../pages/environments/default-env-context/DefaultEnvContext';

interface AddDedupMatchingButtonProps {
  onSelect: (object: string, type?: DedupMatchingType) => void;
  disabled: boolean;
  buttonText: string;
  startIcon?: ComponentType<any>;
}

export const AddDedupMatchingButton = ({
  onSelect,
  disabled,
  buttonText,
  startIcon,
}: AddDedupMatchingButtonProps) => {
  const { permissions } = useAutomationsContext();
  const { evaluatePermissions } = usePermissions();
  const crmOrgId = useDefaultEnvId() ?? '';
  const [isAllowedAddButton] = evaluatePermissions([{ permission: permissions.create, crmOrgId }]);
  const [isTemplatesOpen, setIsTemplatesOpen] = useState(false);

  const onButtonClick = useCallback(() => {
    setIsTemplatesOpen(true);
  }, []);

  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      <RestrictedTooltip
        validation={{ type: 'explicit', allowed: isAllowedAddButton }}
        notAllowedTitle={`To create a new deduplication or matching, please contact your admin.`}
      >
        <Button
          disabled={!isAllowedAddButton || disabled}
          startIcon={startIcon}
          size="small"
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      </RestrictedTooltip>

      <PageTemplateCanvasDialog
        isOpen={isTemplatesOpen}
        title={'Get started with Dedupe & Matching'}
        onCancel={() => setIsTemplatesOpen(false)}
      >
        <DedupTemplateContent onSelect={onSelect} />
      </PageTemplateCanvasDialog>
    </Box>
  );
};
